import { render, staticRenderFns } from "./UniQuestionsAnswer.vue?vue&type=template&id=56f1a122&"
import script from "./UniQuestionsAnswer.vue?vue&type=script&lang=js&"
export * from "./UniQuestionsAnswer.vue?vue&type=script&lang=js&"
import style0 from "./UniQuestionsAnswer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UniQuestionsAnswer.vue"
export default component.exports